import { render, staticRenderFns } from "./ErroredQueue.vue?vue&type=template&id=5dd37a34&scoped=true&"
import script from "./ErroredQueue.vue?vue&type=script&lang=js&"
export * from "./ErroredQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd37a34",
  null
  
)

export default component.exports